import store from "../../store/store";

export const componentKey = "MESSAGING_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setUsersListData: (state, action) => {
      state.userListData = action.payload;
    },
    setIsUserAdded: (state, action) => {
      state.isUserAdded = action.payload;
    },
    setConversationList: (state, action) => {
      state.conversationList = action.payload;
    },
    setCloseCreateGroup: (state, action) => {
      state.closeCreateGroup = action.payload;
    },
    setCloseBroadcast: (state, action) => {
      state.closeBroadcast = action.payload;
    },
    setGroupCreate: (state, action) => {
      state.groupCreated = action.payload;
    },
  },
  initialReducerState: {
    userListData: [],
    conversationList: [],
    isUserAdded: false,
    closeCreateGroup: false,
    closeBroadcast: false,
    groupCreated: [],
  },
});

export const {
  setUsersListData,
  setIsUserAdded,
  setConversationList,
  setCloseCreateGroup,
  setCloseBroadcast,
  setGroupCreate,
} = actions;
